<script lang="ts">
	import { Calendar as CalendarPrimitive } from "bits-ui";
	import { cn } from "@/lib/utils.js";

	let {
		ref = $bindable(null),
		class: className,
		years,
		...restProps
	}: CalendarPrimitive.YearSelectProps = $props();

	const currentYear = new Date().getFullYear();
	const defaultYears = $derived(
		years ?? Array.from({ length: 21 }, (_, i) => currentYear - 10 + i)
	);
</script>

<CalendarPrimitive.YearSelect
	bind:ref
	years={defaultYears}
	class={cn(
		"border-input bg-background ring-offset-background focus-visible:ring-ring h-8 rounded-md border px-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
		className
	)}
	{...restProps}
/>